import { useState } from "react";

export default function useIsLoadingState() {
  const [isLoading, setIsLoading] = useState(false);

  return { isLoading, setIsLoading };
}
